import { useState, useEffect } from 'react';
import Toast from './Toast';
import styles from './ToastContainer.module.css';
import { ToastService } from '../../service/toast.service';

interface ToastItem {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info' | 'code';
  duration?: number;
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    const unsubscribe = ToastService.subscribe((message, type, options) => {
      const id = Date.now() + Math.random(); 
      setToasts(prev => [...prev, { 
        id, 
        message, 
        type,
        duration: options?.duration || 3000
      }]);
    });

    return unsubscribe;
  }, []);

  const handleClose = (id: number) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  return (
    <div className={styles.toastContainer}>
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => handleClose(toast.id)}
          duration={toast.duration}
        />
      ))}
    </div>
  );
}